/**
 * Главная страница — витрина продукта и вход в планировщик.
 *
 * Собирается из блоков `widgets/landing`: первый экран с живым чертежом, шаги,
 * развёртки, возможности, призыв и подвал. Блоки появляются при прокрутке (`useReveal`),
 * но весь текст сразу в разметке — его видят и поисковые роботы.
 * Якоря `#how`, `#features`, `#contacts` завязаны на ссылки меню и подвала.
 */
import { useRef } from "react";
import {
	CtaSection,
	ElevationSection,
	FeaturesSection,
	HeroSection,
	LandingFooter,
	StepsSection,
	useReveal,
	WorkspaceSection,
} from "@/widgets/landing";

export const HomePage = () => {
	const pageRef = useRef<HTMLElement>(null);
	useReveal(pageRef);

	return (
		<main
			ref={pageRef}
			className="min-h-0 flex-1 overflow-y-auto scroll-smooth bg-surface motion-reduce:scroll-auto"
		>
			<HeroSection />
			<StepsSection />
			<WorkspaceSection />
			<ElevationSection />
			<FeaturesSection />
			<CtaSection />
			<LandingFooter />
		</main>
	);
};
